import React from 'react';
import PersonIcon from '@mui/icons-material/Person';
import { useDispatch } from 'react-redux';
import { geocodeByPlaceId } from 'react-google-places-autocomplete';
import useTailwindBrand from 'src/Theme/useTailwindBrand';
// import FormSelect from 'src/Components/FormFields/FormSelect';
import FormRadioYesNo from 'src/Components/FormFields/FormRadioYesNo';
import FormSection from 'src/Components/FormFields/FormSection';
import { otherActivitiesList, useProcuration } from 'src/Hooks/useProcuration';
import { useProcurationContext } from 'src/Contexts/ProcurationContext';
import { FormErrorsThirdPart } from 'src/Hooks/InterfaceProcuration';
import LayoutProcuration from 'src/Components/Procuration/LayoutProcuration';
import FormMultiSelect from 'src/Components/FormFields/FormMultiSelect';
// import AddressComponent from 'src/Utils/Address';
import InputAddressField from 'src/Components/Ui/InputAddressField';

const ThirdPartAe = () => {
    const { classes } = useTailwindBrand();
    const dispatch = useDispatch();
    const context = useProcurationContext();
    const { teachr, prevStep, nextStep, pdfDoc, triggerPdfUpdate, generalProcuration, setPage } = context;

    const {
        formDataThirdPart,
        setFormDataThirdPart,
        errorsThirdPart,
        setErrorsThirdPart,
        handleSelect,
        // handleChange,
        setOtherActivityField,
        setActivitiesOptionsField,
        setFixAddressAtHomeField,
        setUseDomiciliationCompanyField,
        setOptForLiberatoryPaymentField,
        pdfFiledFieldsFirst,
    } = useProcuration({ pdfDoc, teachr, triggerPdfUpdate, setPage });

    const valuesThird = {
        setField: setFormDataThirdPart,
        error: errorsThirdPart,
        setError: setErrorsThirdPart
    }



    // const valuesFourth = {
    //     setField: setFormDataFourthPart,
    //     error: errorsFourthPart,
    //     setError: setErrorsFourthPart
    // }

    // useEffect(() => {
    //     if (generalProcuration?.second?.first) {
    //         const saved = generalProcuration.second.first;
    //         setFormDataThirdPart(prev => ({
    //             otherActivities: saved.otherActivities || prev.otherActivities,
    //             fixAddressAtHome: saved.fixAddressAtHome || prev.fixAddressAtHome,
    //             useDomiciliationCompany: saved.useDomiciliationCompany || prev.useDomiciliationCompany,
    //             addOtherLegalRepresentatives: saved.addOtherLegalRepresentatives || prev.addOtherLegalRepresentatives,
    //             activitiesOptions: saved.activitiesOptions || prev.activitiesOptions
    //         }));
    //         setFormDataFourthPart(prev => ({
    //             renounceInsaisissability: saved.renounceInsaisissability || prev.renounceInsaisissability,
    //             addCommercialName: saved.addCommercialName || prev.addCommercialName,
    //             employEmployees: saved.employEmployees || prev.employEmployees,
    //             employeeCount: saved.employeeCount || prev.employeeCount,
    //             optForLiberatoryPayment: saved.optForLiberatoryPayment || prev.optForLiberatoryPayment
    //         }));
    //     }
    // }, [generalProcuration, setFormDataThirdPart, setFormDataFourthPart]);

    const validate = (): boolean => {
        const newErrorsThird: FormErrorsThirdPart = {
            otherActivities: formDataThirdPart.otherActivities === 0 ? 'Veuillez répondre à cette question' : '',
            fixAddressAtHome: formDataThirdPart.fixAddressAtHome === 0 ? 'Veuillez répondre à cette question' : '',
            useDomiciliationCompany: formDataThirdPart.fixAddressAtHome === 2 && formDataThirdPart.useDomiciliationCompany === 0 ? 'Veuillez répondre à cette question' : '',
            domiciliationAddress: formDataThirdPart.useDomiciliationCompany === 1 && (!formDataThirdPart.domiciliationAddress || formDataThirdPart.domiciliationAddress.trim() === '') ? 'Veuillez renseigner l\'adresse de domiciliation' : '',
            activitiesOptions: formDataThirdPart.otherActivities === 1 && (!Array.isArray(formDataThirdPart.activitiesOptions) || formDataThirdPart.activitiesOptions.length === 0) ? 'Veuillez sélectionner au moins une activité' : '',
            optForLiberatoryPayment: formDataThirdPart.optForLiberatoryPayment === 0 ? 'Veuillez répondre à cette question' : ''
        };
        setErrorsThirdPart(newErrorsThird);
        return !Object.values(newErrorsThird).some(error => error !== '');
    };


    const handleNext = () => {
        if (validate()) {
            const payload = {
                step: 5,
                secondProc: generalProcuration?.secondProc || {},
                thirdProc: generalProcuration?.thirdProc || {},
                fourthProc: generalProcuration?.fourthProc || {},
                fifthProc: formDataThirdPart,
                sixthProc: generalProcuration?.sixthProc || {},
                legalRepProc: generalProcuration?.legalRepProc || [],
                seventhProc: generalProcuration?.seventhProc || {},
                eightProc: generalProcuration?.eightProc || {}
            };
            dispatch({ type: 'SET_AE_INFO', payload });
            nextStep(5);
        }
    };

    const getDomiciliationAddress = (value: string) => {
        geocodeByPlaceId(value).then((response) => {
            const address = response[0].formatted_address;

            // Mettre à jour le state
            setFormDataThirdPart(prev => ({ ...prev, domiciliationAddress: address }));

            // Mettre à jour le champ PDF addressField2 (adresse de domiciliation)
            if (pdfFiledFieldsFirst.addressField2) {
                pdfFiledFieldsFirst.addressField2.setText(address);
            }

            // Effacer l'erreur si présente
            if (errorsThirdPart.domiciliationAddress) {
                setErrorsThirdPart(prev => ({ ...prev, domiciliationAddress: '' }));
            }

            setPage(3);

            // Déclencher la mise à jour du PDF
            if (triggerPdfUpdate) {
                triggerPdfUpdate();
            }
        }).catch(() => {
            setErrorsThirdPart(prev => ({ ...prev, domiciliationAddress: 'Erreur lors de la récupération de l\'adresse' }));
        });
    };

    return (
        <>
            <LayoutProcuration
                title="Informations complémentaires"
                icon={<PersonIcon className={`w-6 h-6 ${classes.primaryText}`} />}
                nextStep={handleNext}
                prevStep={prevStep}
                currentStep={2}
                totalSteps={4}
            >
                <FormSection title="Configuration de votre micro-entreprise">
                    <div className="space-y-6">
                        <FormRadioYesNo
                            label="Souhaitez-vous effectuer une ou plusieurs autres activités de service à la personne ?"
                            subtitle={
                                <a
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href="https://www.servicesalapersonne.gouv.fr/tout-savoir-sur-les-services-la-personne/les-26-activites-de-services-la-personne"
                                    className={`md:text-base underline text-blue-600 text-xs ${classes.fontFamily} font-medium italic hover:text-blue-800 transition-colors`}
                                >
                                    👉 Liste des services à la personne 👈
                                </a>
                            }
                            value={formDataThirdPart.otherActivities}
                            onChange={(value) => handleSelect(value, 'otherActivities', setOtherActivityField, valuesThird, 3)}
                            error={errorsThirdPart.otherActivities}
                            required={true}
                            name="otherActivities"
                        />

                        {formDataThirdPart.otherActivities === 1 && (
                            <div className="lg:col-span-2">
                                <FormMultiSelect
                                    callback={(values: number[]) => {
                                        setFormDataThirdPart(prev => ({ ...prev, activitiesOptions: values }));
                                        setActivitiesOptionsField(values);
                                        if (errorsThirdPart.activitiesOptions) {
                                            setErrorsThirdPart(prev => ({ ...prev, activitiesOptions: '' }));
                                        }
                                        if (triggerPdfUpdate) {
                                            triggerPdfUpdate();
                                        }
                                    }}
                                    required={true}
                                    error={errorsThirdPart.activitiesOptions}
                                    label="Quelle(s) activité(s) souhaitez-vous exercer ?"
                                    placeholder="Sélectionner une ou plusieurs activités"
                                    data={otherActivitiesList}
                                    customClass={`bg-white ${classes.fontFamily} py-[6px] shadow-md shadow-[rgba(0,0,0,25%)] text-[16px] border ${errorsThirdPart.activitiesOptions ? `${classes.errorBorder} border-l-4` : 'hover:border-2 hover:border-gray-400'}`}
                                    defaultValue={formDataThirdPart.activitiesOptions}
                                />
                            </div>
                        )}

                        <FormRadioYesNo
                            label="Souhaitez-vous fixer l'adresse de votre auto-entreprise à votre domicile ?"
                            value={formDataThirdPart.fixAddressAtHome}
                            onChange={(value) => {
                                handleSelect(value, 'fixAddressAtHome', setFixAddressAtHomeField, valuesThird, 3);
                                // Si "Oui" est sélectionné (valeur 1), réinitialiser useDomiciliationCompany et domiciliationAddress
                                if (value === 1) {
                                    setFormDataThirdPart(prev => ({
                                        ...prev,
                                        useDomiciliationCompany: 0,
                                        domiciliationAddress: ''
                                    }));
                                    // Réinitialiser le champ PDF addressField2
                                    if (pdfFiledFieldsFirst.addressField2) {
                                        pdfFiledFieldsFirst.addressField2.setText('');
                                    }
                                    // Effacer les erreurs
                                    setErrorsThirdPart(prev => ({
                                        ...prev,
                                        useDomiciliationCompany: '',
                                        domiciliationAddress: ''
                                    }));
                                }
                            }}
                            error={errorsThirdPart.fixAddressAtHome}
                            required={true}
                            name="fixAddressAtHome"
                        />

                        {formDataThirdPart.fixAddressAtHome === 2 && (
                            <>
                                <FormRadioYesNo
                                    label="Avez-vous recours à une société de domiciliation ?"
                                    value={formDataThirdPart.useDomiciliationCompany}
                                    onChange={(value) => handleSelect(value, 'useDomiciliationCompany', setUseDomiciliationCompanyField, valuesThird, 3)}
                                    error={errorsThirdPart.useDomiciliationCompany}
                                    required={formDataThirdPart.fixAddressAtHome === 2}
                                    name="useDomiciliationCompany"
                                />

                                {formDataThirdPart.useDomiciliationCompany === 1 && (
                                    <FormSection title="Adresse de domiciliation" className="border-gray-200">
                                        {/* <div className="bg-white border shadow-md rounded-lg py-1 px-2 relative transition-all duration-200">
                                            <label className={`block text-sm font-semibold mb-1 ${errorsThirdPart.domiciliationAddress ? classes.error : classes.text} ${classes.fontFamily}`}>
                                                Adresse de domiciliation {errorsThirdPart.domiciliationAddress && <span className={classes.error}>*</span>}
                                            </label>
                                            <AddressComponent
                                                default={formDataThirdPart.domiciliationAddress}
                                                getPlaceId={getDomiciliationAddress}
                                                placeholder="Ex: 2 rue de la Seine, 94004"
                                            />
                                        </div>
                                        {errorsThirdPart.domiciliationAddress && (
                                            <p className={`text-sm mt-1 ${classes.error} font-medium`}>{errorsThirdPart.domiciliationAddress}</p>
                                        )} */}
                                        <InputAddressField
                                            label='Adresse de domiciliation'
                                            default={formDataThirdPart.domiciliationAddress}
                                            getPlaceId={getDomiciliationAddress}
                                            placeholder="Ex: 2 rue de la Seine, 94004"
                                            error={errorsThirdPart.domiciliationAddress}
                                        />
                                    </FormSection>
                                )}
                            </>
                        )}


                        <FormRadioYesNo
                            label="Souhaitez-vous opter pour le versement libératoire ?"
                            subtitle={
                                <a
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href="https://www.economie.gouv.fr/entreprises/gerer-sa-micro-entreprise/micro-entreprise-comment-fonctionne-le-versement-liberatoire"
                                    className={`md:text-base underline text-blue-600 text-xs ${classes.fontFamily} font-medium italic hover:text-blue-800 transition-colors`}
                                >
                                    👉 Cliquez-ici pour obtenir plus d'informations sur le prélèvement libératoire 👈
                                </a>
                            }
                            value={formDataThirdPart.optForLiberatoryPayment}
                            onChange={(value) => handleSelect(value, 'optForLiberatoryPayment', setOptForLiberatoryPaymentField, valuesThird, 4)}
                            error={errorsThirdPart.optForLiberatoryPayment}
                            required={true}
                            name="optForLiberatoryPayment"
                        />
                    </div>
                </FormSection>
            </LayoutProcuration>


        </>
    );
};

export default ThirdPartAe;
